import VerifySsn from 'features/reactivation/challenges/VerifySsn/VerifySsn';
import React from 'react';

export default function VerifySsnPage() {
  return <VerifySsn />;
}
